import { memo } from "react";
import { SupportingDocument } from "../../constants/common";
import CheckboxPermitPDF from "../inputs/CheckboxPermitPDF";

interface SupportingDocumentsProps {
  sectionNumber: number
  permitDetails: Record<string, any> | null;
  documents: SupportingDocument[]
}

const SupportingDocuments = ({
  sectionNumber,
  permitDetails,
  documents
}: SupportingDocumentsProps) => {
  const isDocumentChecked = (documentKey: string): boolean => {
    if (!documentKey || !permitDetails) return false;
    const value = permitDetails[documentKey as keyof typeof permitDetails];
    return (typeof value === "number" && value === 1) || (typeof value === "boolean" && value === true);
  };

  return (
    <div>
      <div className="bg-green-primary text-center border-b border-black py-0.5">
        <span className="text-[10px] font-bold text-white">
          Section {sectionNumber}: Supporting Documents
        </span>
      </div>

      <div className="text-[10px] px-1 font-bold bg-white">
        Tick the supporting document ( ✓ )
      </div>

      <div className="grid grid-cols-2 mx-1 border-x border-t border-black">
        {documents.slice(0,).map((doc, index) => (
          <CheckboxPermitPDF
            key={index}
            item={doc}
            isLastColumn={false}
            checked={isDocumentChecked(doc.key)}
          />
        ))}
      </div>
    </div>
  );
};

export default memo(SupportingDocuments);
